import React from 'react';
import AuthAdminUserModel from '../../code/models/AuthAdminUserModel';
import CreditRangeInfo from '../../code/models/CreditRangeInfo';
import ApiCreditRange from '../../code/api/ApiCreditRange';
import Api_Config from '../../code/api/ApiConfig';
import { ImportDocumentType } from '../../code/enums/Enums';
import ApiDocument from '../../code/api/ApiDocument';
import Auth from "../../code/auth/Auth";
import FileUploaderModalForm from "../FileUploaderModalForm";
import CreditRangeReportData from "../../code/models/CreditRangeReportData";
import CclDataTable, { CclDataTableColumnDef, CclDataTableColumnType } from "../CclDataTable";
import Customer from "../../code/models/Customer";
import parsePhoneNumber from 'libphonenumber-js';

import '../../css/admincreditrangeform.css';

interface IAdminCreditRangeForm {
    adminUser: AuthAdminUserModel;
}

export default function AdminCreditRangeForm({ adminUser }: IAdminCreditRangeForm) {
    const [currentInfo, setCurrentInfo] = React.useState<CreditRangeInfo | null>(null);
    const [reportData, setReportData] = React.useState<CreditRangeReportData[]>([]);

    React.useEffect(() => {
        loadHistory();
        loadOutOfRangeCustomers();
    }, []);

    function loadHistory() {
        ApiCreditRange.getCreditRangeInfo().then(data => {
            if (!!data) {
                setCurrentInfo(data);

                var stat = data.lastImport?.status;
                if (!!stat && stat.toLowerCase() !== "complete" && stat.toLowerCase() !== "error") {
                    setTimeout(loadHistory, 5000);
                } else {
                    loadOutOfRangeCustomers();
                }
            }
        });
    }

    function loadOutOfRangeCustomers() {
        ApiCreditRange.getOutOfRangeCustomers().then(data => {
            if (!!data) {
                setReportData(data);
            }
        });
    }

    var comp = Api_Config.getSelectedCompany();

    const reportColumnDefs: CclDataTableColumnDef[] = [
        {
            fieldName: "customer",
            title: "Name",
            visible: true,
            type: CclDataTableColumnType.Data,
            formatData(val, rowData) { return val.name; }
        },
        {
            fieldName: "customer",
            title: "Phone",
            visible: true,
            type: CclDataTableColumnType.Data,
            formatData(val, rowData) { return getFormattedPhone(val); }
        },
        {
            fieldName: "rangeType",
            title: "Range Type",
            visible: true,
            type: CclDataTableColumnType.Data
        },
        {
            fieldName: "min",
            title: "Min",
            visible: true,
            type: CclDataTableColumnType.Data
        },
        {
            fieldName: "max",
            title: "Max",
            visible: true,
            type: CclDataTableColumnType.Data
        },
        {
            fieldName: "allowableMin",
            title: "CR Min",
            visible: true,
            type: CclDataTableColumnType.Data
        },
        {
            fieldName: "allowableMax",
            title: "CR Max",
            visible: true,
            type: CclDataTableColumnType.Data
        }
    ];

    function getFormattedPhone(rowData: Customer): string {
        if (!rowData.formattedPhone) {
            const phnnmbr = `+${rowData.phoneCountryCode || "1"}${rowData.phone}`;
            const phoneNumber = parsePhoneNumber(phnnmbr);
            if (phoneNumber?.isPossible()) {
                rowData.formattedPhone = phoneNumber?.formatInternational() || phnnmbr;
            } else {
                rowData.formattedPhone = phnnmbr;
            }
        }
        return rowData.formattedPhone;
    }

    function getLastFileName(): any {
        var currentFileGroup = currentInfo?.currentFileGroup;

        if (currentFileGroup != null) {
            if (currentFileGroup.bidPeriodFiles.length > 0) {
                const theFile = currentFileGroup.bidPeriodFiles[0];
                let token = Auth.getAuthToken();
                return (
                    <a href={`${comp.adminApiUrl}/document/doc/${theFile.bidPeriodFileId}?t=${token}`} target="_blank" >
                        {currentFileGroup.bidPeriodFiles[0].fileName}
                    </a>
                )
            }
        }
        return "N/A";
    }

    function onUploadReportUploadSuccess(fileGroupId: number) {
        ApiDocument.queueImportRequest(fileGroupId).then(resp => {
            loadHistory();
        });
    }

    function handleReImportClick(fileGroupId: number) {
        ApiDocument.queueImportRequest(fileGroupId).then(resp => {
            loadHistory();
        });
    }

    return (
        <React.Fragment>
            <div className="creditrange-form">
                <div className="creditrange-div">
                    <span className="creditrange-title">Credit Range</span>
                    {!!currentInfo && <span className="creditrange-label">Bid Period: {currentInfo?.bidPeriod.month}</span>}
                </div>
                <div className="creditrange-info">
                    <div>
                        <span className="creditrange-label">Last Import Date:</span>
                        {(!currentInfo || !currentInfo.lastImport) &&
                            <span className="creditrange-data">None for this bid period.</span>}
                        {!!currentInfo && !!currentInfo.lastImport &&
                            <span className="creditrange-data">{new Date(currentInfo?.lastImport?.statusDate).toLocaleString()}</span>}
                    </div>
                    <div>
                        <span className="creditrange-label">Last Import Status:</span>
                        {(!currentInfo || !currentInfo.lastImport) && <span className="creditrange-data">N/A</span>}
                        {!!currentInfo && !!currentInfo.lastImport && <span className="creditrange-data">{currentInfo?.lastImport?.status}</span>}
                    </div>
                    <div>
                        <span className="creditrange-label">Last Import Message:</span>
                        {(!currentInfo || !currentInfo.lastImport) && <span className="creditrange-data">N/A</span>}
                        {!!currentInfo && !!currentInfo.lastImport && <span className="creditrange-data">{currentInfo?.lastImport?.statusMessage}</span>}
                    </div>
                    <br />
                    <div>
                        <span className="creditrange-label">Last Report Upload Date:</span>
                        {(!currentInfo || !currentInfo.currentFileGroup) && <span className="creditrange-data">None for this bid period.</span>}
                        {!!currentInfo && !!currentInfo.currentFileGroup &&
                            <span className="creditrange-data">{new Date(currentInfo?.currentFileGroup?.statusDate).toLocaleString()}</span>}
                    </div>
                    <div>
                        <span className="creditrange-label">Last Report Upload Status:</span>
                        {(!currentInfo || !currentInfo.currentFileGroup) && <span className="creditrange-data">N/A</span>}
                        {!!currentInfo && !!currentInfo.currentFileGroup && <span className="creditrange-data">{currentInfo?.currentFileGroup?.groupStatus}</span>}

                    </div>
                    <div>
                        <span className="creditrange-label">Last File Name:</span>
                        {(!currentInfo || !currentInfo.currentFileGroup) && <span className="creditrange-data">N/A</span>}
                        {!!currentInfo && !!currentInfo.currentFileGroup && <span className="creditrange-data">{getLastFileName()}</span>}
                    </div>
                    {!!currentInfo?.lastImport && <div className="creditrange-restart">
                        <button onClick={() => handleReImportClick(currentInfo?.lastImport?.bidPeriodFileGroupId || 0)}
                            className="btn btn-success btn-md">Restart Import</button>
                    </div>}
                </div>
                <div className="creditrange-fileuploader">
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;</span><FileUploaderModalForm
                        title="Credit Range"
                        multiUpload={false}
                        fileGroup={ImportDocumentType.credit_range}
                        fileGroupId={currentInfo?.currentFileGroup?.bidPeriodFileGroupId}
                        buttonTextChoose="Browse Documents"
                        buttonTextUpload="Upload and Import"
                        buttonTextMain="Import New Credit Range Document"
                        newGroupOnUpload={true}
                        onUploadSuccess={onUploadReportUploadSuccess}
                    />
                </div>
            </div>
            <div className="creditrange-tablewrapper">
                <CclDataTable name={"admcreditrangetable"} tableData={reportData} columnDefinitions={reportColumnDefs} rowSelect={true} />
            </div>
        </React.Fragment>
    )
}

